<template>
    <cookie-law theme="dark-lime" buttonText="Ok" storageName="rem3rch:accepted" storageType="cookies">
        <div slot="message">
            We use cookies to ensure that we give you the best experience on our website. If you continue without changing your settings, we'll assume
            that you are happy to receive cookies on the REM3RCH website. However, you can change your cookie settings at any time.
            <a class="rgpd_link" href="https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser" target="_blank">Find Out More</a>
        </div>
        <div slot="buttonText">Ok</div>
    </cookie-law>
</template>

<script>
import CookieLaw from "vue-cookie-law";
export default {
    components: { CookieLaw }
};
</script>

<style lang="scss">
.Cookie {
    background-color: #343434;
    .rgpd_link {
        color: #ffffff;
        &:hover {
            text-decoration: underline;
        }
    }
    .Cookie__button {
        background: #c779d0 !important;
        transition: 0.3s ease-in-out;
        &:hover {
            background: #a364ab !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Cookie.vue?047e77a2